import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  StartCustomerDocumentProcessingMutation,
  StartCustomerDocumentProcessingMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { UpdateFileStatus } from "../../../../components/content_library/DocumentUploadProgressProvider";
import { useGraphQlMutation } from "../useGraphQlClient";

const START_CUSTOMER_DOCUMENT_PROCESSING_QUERY = graphql(`
  mutation startCustomerDocumentProcessing($docId: String!) {
    startCustomerDocumentProcessing(docId: $docId) {
      id
      resourceId
      fileName
      description
      documentType
      uiPath
    }
  }
`);

export function useStartCustomerDocumentProcessing(
  updateFileStatus: UpdateFileStatus,
  options?: UseMutationOptions<
    StartCustomerDocumentProcessingMutation,
    unknown,
    StartCustomerDocumentProcessingMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(START_CUSTOMER_DOCUMENT_PROCESSING_QUERY, {
    ...options,

    onError(error, variables, context) {
      updateFileStatus({
        fileName: undefined,
        documentId: variables.docId,
        updates: {
          isError: true,
          isFinished: true,
        },
      });
      options?.onError?.(error, variables, context);
    },
  });

  return { data: data?.startCustomerDocumentProcessing, ...rest };
}
